<template>
  <div id="app">
    <div class="tab">
      <ul>
        <li><span :class="type==1?'active':''"><a href="/message?type=1">报告消息</a></span></li>
        <li><span :class="type==2?'active':''"><a href="/message?type=2">会员消息</a></span></li>
        <li><span :class="type==3?'active':''"><a href="/message?type=3">系统消息</a></span></li>
      </ul>
    </div>
    <div class="message">
      <ul>
       <li v-for="(item,key) in messageList" :key="key">
          <div class="title">{{item.message}}</div>
          <div class="date">{{item.strDate}}</div>
          <div class="clear_both"></div>
        </li>
      
      </ul>
    </div>
  </div>
</template>


 
<style scoped src="../../../static/css/Common.css"></style>
<style scoped src="../../../static/css/Message.css"></style>

<script>
import {messageApi} from '@/service/allApi'
export default {
  data(){
    return {
      type : 1,
      messageList:[]
    }
  },
  created(){
    if(this.$route.query.type){
      this.type = this.$route.query.type
    }
  },
  mounted(){
    this.loadMessage()
  },
  methods:{
    async loadMessage(){
      const res = await messageApi(this.type)
      if(res.data.code == 100){
        this.messageList = res.data.list
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/iframe/Message.vue